import React from "react";
import styled, { css } from "styled-components";

type ContractStatusBadgeProps = {
    isActive: boolean;
    size?: "sm" | "md" | "lg";
};

const Badge = styled.span<{ isActive: boolean; size: "sm" | "md" | "lg" }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  border: 1px solid;

  ${({ size }) =>
        size === "sm" &&
        css`
      font-size: 0.75rem;
      padding: 0.125rem 0.5rem;
    `}

  ${({ size }) =>
        size === "md" &&
        css`
      font-size: 0.875rem;
      padding: 0.25rem 0.75rem;
    `}

  ${({ size }) =>
        size === "lg" &&
        css`
      font-size: 1rem;
      padding: 0.375rem 1rem;
    `}

  ${({ isActive }) =>
        isActive
            ? css`
          background-color: #dcfce7;
          color: #15803d;
          border-color: #86efac;
        `
            : css`
          background-color: #fee2e2;
          color: #b91c1c;
          border-color: #fca5a5;
        `}
`;

export const ContractStatusBadge: React.FC<ContractStatusBadgeProps> = ({
    isActive,
    size = "md",
}) => {
    return <Badge isActive={isActive} size={size}>{isActive ? "Activo" : "Inactivo"}</Badge>;
};
